import YPanel from './Panel';

export { YPanel };
export default YPanel;
